module.exports = __webpack_public_path__ + "static/img/no_data.c017dc5b.png";